/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './AiEngineOptimizationService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService#getTopPerformingContent
 */
export const GET_TOP_PERFORMING_CONTENT_QUERY_FIELD_NAME = 'com_hubspot_ai_engine_optimization_rpc_AiEngineOptimizationService_getTopPerformingContent';
export const GET_TOP_PERFORMING_CONTENT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_TOP_PERFORMING_CONTENT_QUERY_FIELD_NAME,
  args: ['contentType', 'limit', 'businessUnitId', 'performanceCriteria', 'searchCriteria'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getTopPerformingContentRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService#getTopEntities
 */
export const GET_TOP_ENTITIES_QUERY_FIELD_NAME = 'com_hubspot_ai_engine_optimization_rpc_AiEngineOptimizationService_getTopEntities';
export const GET_TOP_ENTITIES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_TOP_ENTITIES_QUERY_FIELD_NAME,
  args: ['contentType', 'maxEntities', 'maxEntityRelationships', 'languageCode', 'businessUnitId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getTopEntitiesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService#getTopicRecommendations
 */
export const GET_TOPIC_RECOMMENDATIONS_QUERY_FIELD_NAME = 'com_hubspot_ai_engine_optimization_rpc_AiEngineOptimizationService_getTopicRecommendations';
export const GET_TOPIC_RECOMMENDATIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_TOPIC_RECOMMENDATIONS_QUERY_FIELD_NAME,
  args: ['contentType', 'contentTypeList', 'maxTopEntities', 'maxTopTriples', 'iSO6391LanguageCode', 'productAndServiceDescription', 'idealCustomerProfile', 'contentStrategy', 'businessUnitId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getTopicRecommendationsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService#getKeywordsWithDomainInAiOverview
 */
export const GET_KEYWORDS_WITH_DOMAIN_IN_AI_OVERVIEW_QUERY_FIELD_NAME = 'com_hubspot_ai_engine_optimization_rpc_AiEngineOptimizationService_getKeywordsWithDomainInAiOverview';
export const GET_KEYWORDS_WITH_DOMAIN_IN_AI_OVERVIEW_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_KEYWORDS_WITH_DOMAIN_IN_AI_OVERVIEW_QUERY_FIELD_NAME,
  args: ['domain'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getKeywordsWithDomainInAiOverviewRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService#getContentInAiOverview
 */
export const GET_CONTENT_IN_AI_OVERVIEW_QUERY_FIELD_NAME = 'com_hubspot_ai_engine_optimization_rpc_AiEngineOptimizationService_getContentInAiOverview';
export const GET_CONTENT_IN_AI_OVERVIEW_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CONTENT_IN_AI_OVERVIEW_QUERY_FIELD_NAME,
  args: ['domain', 'content'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getContentInAiOverviewRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService#getEntitiesWithContentInAiOverview
 */
export const GET_ENTITIES_WITH_CONTENT_IN_AI_OVERVIEW_QUERY_FIELD_NAME = 'com_hubspot_ai_engine_optimization_rpc_AiEngineOptimizationService_getEntitiesWithContentInAiOverview';
export const GET_ENTITIES_WITH_CONTENT_IN_AI_OVERVIEW_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ENTITIES_WITH_CONTENT_IN_AI_OVERVIEW_QUERY_FIELD_NAME,
  args: ['entities', 'contentInAiOverview'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getEntitiesWithContentInAiOverviewRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService#listTopics
 */
export const LIST_TOPICS_QUERY_FIELD_NAME = 'com_hubspot_ai_engine_optimization_rpc_AiEngineOptimizationService_listTopics';
export const LIST_TOPICS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_TOPICS_QUERY_FIELD_NAME,
  args: ['offset', 'businessUnitId', 'topicsByVisibilityStatuses', 'pageLength'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.listTopicsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService#listContentForTopic
 */
export const LIST_CONTENT_FOR_TOPIC_QUERY_FIELD_NAME = 'com_hubspot_ai_engine_optimization_rpc_AiEngineOptimizationService_listContentForTopic';
export const LIST_CONTENT_FOR_TOPIC_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_CONTENT_FOR_TOPIC_QUERY_FIELD_NAME,
  args: ['topicId'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.listContentForTopicRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService#listTopicsForContent
 */
export const LIST_TOPICS_FOR_CONTENT_QUERY_FIELD_NAME = 'com_hubspot_ai_engine_optimization_rpc_AiEngineOptimizationService_listTopicsForContent';
export const LIST_TOPICS_FOR_CONTENT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_TOPICS_FOR_CONTENT_QUERY_FIELD_NAME,
  args: ['contentId'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.listTopicsForContentRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService#updateAssociatedContentForTopic
 */
export const UPDATE_ASSOCIATED_CONTENT_FOR_TOPIC_MUTATION_FIELD_NAME = 'com_hubspot_ai_engine_optimization_rpc_AiEngineOptimizationService_updateAssociatedContentForTopic';
export const UPDATE_ASSOCIATED_CONTENT_FOR_TOPIC_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_ASSOCIATED_CONTENT_FOR_TOPIC_MUTATION_FIELD_NAME,
  args: ['topicId', 'contentToAdd', 'contentToRemove'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.updateAssociatedContentForTopicRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService#startPopulation
 */
export const START_POPULATION_MUTATION_FIELD_NAME = 'com_hubspot_ai_engine_optimization_rpc_AiEngineOptimizationService_startPopulation';
export const START_POPULATION_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: START_POPULATION_MUTATION_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.startPopulationRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService#updateTopicVisibility
 */
export const UPDATE_TOPIC_VISIBILITY_MUTATION_FIELD_NAME = 'com_hubspot_ai_engine_optimization_rpc_AiEngineOptimizationService_updateTopicVisibility';
export const UPDATE_TOPIC_VISIBILITY_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_TOPIC_VISIBILITY_MUTATION_FIELD_NAME,
  args: ['topicId', 'visibilityStatus'],
  fetcher(request, ctx) {
    var _ctx$customClient12;
    return ((_ctx$customClient12 = ctx.customClient) !== null && _ctx$customClient12 !== void 0 ? _ctx$customClient12 : chirpClient).call(References.updateTopicVisibilityRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService#updateTopicName
 */
export const UPDATE_TOPIC_NAME_MUTATION_FIELD_NAME = 'com_hubspot_ai_engine_optimization_rpc_AiEngineOptimizationService_updateTopicName';
export const UPDATE_TOPIC_NAME_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_TOPIC_NAME_MUTATION_FIELD_NAME,
  args: ['topicId', 'newName'],
  fetcher(request, ctx) {
    var _ctx$customClient13;
    return ((_ctx$customClient13 = ctx.customClient) !== null && _ctx$customClient13 !== void 0 ? _ctx$customClient13 : chirpClient).call(References.updateTopicNameRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService#submitFeedback
 */
export const SUBMIT_FEEDBACK_MUTATION_FIELD_NAME = 'com_hubspot_ai_engine_optimization_rpc_AiEngineOptimizationService_submitFeedback';
export const SUBMIT_FEEDBACK_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SUBMIT_FEEDBACK_MUTATION_FIELD_NAME,
  args: ['inferenceId', 'feedbackText', 'positiveFeedback'],
  fetcher(request, ctx) {
    var _ctx$customClient14;
    return ((_ctx$customClient14 = ctx.customClient) !== null && _ctx$customClient14 !== void 0 ? _ctx$customClient14 : chirpClient).call(References.submitFeedbackRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService#getTopicFitRecommendations
 */
export const GET_TOPIC_FIT_RECOMMENDATIONS_QUERY_FIELD_NAME = 'com_hubspot_ai_engine_optimization_rpc_AiEngineOptimizationService_getTopicFitRecommendations';
export const GET_TOPIC_FIT_RECOMMENDATIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_TOPIC_FIT_RECOMMENDATIONS_QUERY_FIELD_NAME,
  args: ['contentId'],
  fetcher(request, ctx) {
    var _ctx$customClient15;
    return ((_ctx$customClient15 = ctx.customClient) !== null && _ctx$customClient15 !== void 0 ? _ctx$customClient15 : chirpClient).call(References.getTopicFitRecommendationsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService#applyRecommendations
 */
export const APPLY_RECOMMENDATIONS_MUTATION_FIELD_NAME = 'com_hubspot_ai_engine_optimization_rpc_AiEngineOptimizationService_applyRecommendations';
export const APPLY_RECOMMENDATIONS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: APPLY_RECOMMENDATIONS_MUTATION_FIELD_NAME,
  args: ['contentId', 'applyRecommendationIds', 'unapplyRecommendationIds'],
  fetcher(request, ctx) {
    var _ctx$customClient16;
    return ((_ctx$customClient16 = ctx.customClient) !== null && _ctx$customClient16 !== void 0 ? _ctx$customClient16 : chirpClient).call(References.applyRecommendationsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});